import { Pagination } from "@mui/material";
import { CaretLeftIcon, Cross2Icon, UploadIcon } from "@radix-ui/react-icons";
import { MoreHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import modelCommune from "../../assets/model-fichier/model_commune.xlsx";
import { Loader } from "../../components/Widget/Loader";
import { store } from "../../services/service";
import { useStoreCommune } from "../../store/storeCommune";
import {
  AJOUTER_COMMUNE,
  CHARGER_FICHIER_COMMUNE,
  LISTE_COMMUNE_PAR_PAGE,
  MODIFIER_ETAT_COMMUNE,
} from "../../Utils/constant";
import { Quartier } from "./Quartier";

export const Commune = () => {
  const [isSubmit, setIsSubmit] = useState(false);
  const communes = useStoreCommune();
  const [message, setMessage] = useState("");
  const [fichier, setFichier] = useState([]);
  const [item, setItem] = useState(null);
  const [selectItem, setSelectItem] = useState(null);
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const handleChangeFichier = (e) => {
    console.log(e.target.files);
    const selectedFiles = e.target.files;
    const newFiles = Array.from(selectedFiles);
    setFichier((prevFiles) => [...prevFiles, ...newFiles]);
  };

  useEffect(() => {
    communes.getData(`${LISTE_COMMUNE_PAR_PAGE}?page=0&param=&size=10`);
  }, []);

  useEffect(() => {
    if (selectItem) {
      setValue("designation", selectItem.designation);
      setValue("etat", selectItem.etat || "ACTIF");
    }
  }, [selectItem, setValue]);

  const more = (page) => {
    communes.getData(
      `${LISTE_COMMUNE_PAR_PAGE}?page=${page - 1}&param=&size=10`
    );
  };

  const submit = (data) => {
    setIsSubmit(true);
    const payload = {
      ...data,
      id: selectItem?.id,
    };
    store(AJOUTER_COMMUNE, "application/json", payload)
      .then((res) => {
        setIsSubmit(false);
        if (res.status === 200) {
          reset();
          setSelectItem(null);
          communes.getData(`${LISTE_COMMUNE_PAR_PAGE}?page=0&param=&size=10`);
          document.getElementById("update").close();
          toast.success("Mise à jour réussie");
        }
      })
      .catch((err) => {
        setIsSubmit(false);
        toast.error(err.response.data.donnee);
      });
  };

  const getEtatBadge = (etat) => {
    const badges = {
      ACTIF: "badge-success",
      INACTIF: "badge-warning",
      SUPPRIME: "badge-error",
    };
    return badges[etat] || "badge-ghost";
  };

  const getEtatLabel = (etat) => {
    const labels = {
      ACTIF: "Actif",
      INACTIF: "Inactif",
      SUPPRIME: "Supprimé",
    };
    return labels[etat] || etat;
  };

  return (
    <>
      {item === null ? (
        <div className="my-3">
          <p className="font-semibold text-lg">Liste des communes</p>
          <div className="mt-4 lg:flex item-center gap-2 w-full">
            <input
              onChange={(e) =>
                communes.getData(
                  `${LISTE_COMMUNE_PAR_PAGE}?page=0&param=${e.target.value}&size=10`
                )
              }
              type="text"
              placeholder="Rechercher element..."
              className="input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
            />
            <button
              onClick={() => document.getElementById("upload").showModal()}
              className="btn btn-sm ml-auto  bg-black text-white"
            >
              <UploadIcon /> Charger un fichier
            </button>

            <dialog id="update" className="modal ">
              <div className="modal-box ">
                <div className="modal-action">
                  <h1 className="mr-auto text-xl font-mtn font-bold">
                    Modification de commune
                  </h1>
                  <form method="dialog">
                    <button
                      id="fermer_create_trajet"
                      className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                    >
                      ✕
                    </button>
                  </form>
                </div>
                <form onSubmit={handleSubmit(submit)} className="px-2">
                  <div className="my-4 space-y-4">
                    <div className="my-2">
                      <label htmlFor="" className="text-sm font-medium">
                        Designation <span className="text-red-500">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder=""
                        className="input input-bordered px-3 w-full h-10 text-gray-900 placeholder:text-gray-400"
                        {...register("designation", { required: true })}
                      />
                      {errors.designation && (
                        <span className="text-sm text-rose-600">
                          Ce champs est obligatoire
                        </span>
                      )}
                    </div>

                    <button
                      type="submit"
                      disabled={isSubmit ? true : false}
                      className={`${
                        !isSubmit
                          ? "text-black bg-main"
                          : "text-slate-800 bg-slate-200 "
                      } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800`}
                    >
                      {!isSubmit ? "Enregistrer" : "Veuillez patientez..."}{" "}
                      {isSubmit ? (
                        <span className="loading loading-dots loading-xs"></span>
                      ) : null}
                    </button>
                  </div>
                </form>
              </div>
            </dialog>

            <dialog id="change_status" className="modal">
              <div className="modal-box">
                <div className="modal-action">
                  <h1 className="mr-auto text-xl font-mtn font-bold">
                    Modifier l'état
                  </h1>
                  <form method="dialog">
                    <button
                      id="close_change_status"
                      className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                    >
                      ✕
                    </button>
                  </form>
                </div>
                <div className="px-2 py-4">
                  <div className="mb-4">
                    <p className="text-sm text-gray-600 mb-2">
                      Commune :{" "}
                      <span className="font-semibold">
                        {selectItem?.designation}
                      </span>
                    </p>
                  </div>

                  <div className="my-4">
                    <label htmlFor="" className="text-sm font-medium">
                      Nouvel état <span className="text-red-500">*</span>
                    </label>
                    <select
                      className="select select-bordered w-full text-gray-900 mt-2"
                      {...register("etat", { required: true })}
                    >
                      <option value="">Selectionnez un etat</option>
                      <option value="ACTIF">Actif</option>
                      <option value="INACTIF">Inactif</option>
                      <option value="SUPPRIME">Supprimé</option>
                    </select>
                    {errors.etat && (
                      <span className="text-sm text-rose-600">
                        Ce champs est obligatoire
                      </span>
                    )}
                  </div>

                  <button
                    onClick={handleSubmit((data) => {
                      setIsSubmit(true);
                      store(
                        MODIFIER_ETAT_COMMUNE +
                          `/${selectItem?.id}?etat=${data.etat}`,
                        "application/json",
                        {}
                      )
                        .then((res) => {
                          setIsSubmit(false);
                          reset();
                          setSelectItem(null);
                          communes.getData(
                            `${LISTE_COMMUNE_PAR_PAGE}?page=0&param=&size=10`
                          );
                          document
                            .getElementById("close_change_status")
                            .click();
                          toast.success("État modifié avec succès");
                        })
                        .catch((err) => {
                          setIsSubmit(false);
                          toast.error(err.response.data.donnee);
                        });
                    })}
                    disabled={isSubmit ? true : false}
                    className={`${
                      !isSubmit
                        ? "text-black bg-main"
                        : "text-slate-800 bg-slate-200 "
                    } w-full my-3 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-bold rounded-lg text-sm px-5 py-2.5 text-center`}
                  >
                    {!isSubmit ? "Modifier l'état" : "Veuillez patientez..."}{" "}
                    {isSubmit ? (
                      <span className="loading loading-dots loading-xs"></span>
                    ) : null}
                  </button>
                </div>
              </div>
            </dialog>

            <dialog id="upload" className="modal rounded-none">
              <div className="modal-box w-10/12 max-w-xl">
                <div className="modal-action">
                  <h1 className="font-mtn mr-auto text-2xl font-bold">
                    Charger un fichier
                  </h1>
                  <form method="dialog">
                    <button id="close_upload" className="btn btn-sm">
                      <Cross2Icon />
                    </button>
                  </form>
                </div>
                <div>
                  <p className="text-xs text-red-600">{message}</p>
                  <label className="form-contro w-full">
                    <div className="label flex flex-col justify-start items-start gap-1.5">
                      <span className="label-text  font-medium text-gray-400"></span>
                      <div className="w-full">
                        <div className="text-black py-8 border-dashed border bg-gray-50 border-gray-300 px-3 my-2 w-full rounded-md shadow-sm ">
                          <div className="flex justify-center mb-3">
                            <UploadIcon />
                          </div>

                          <p className="text-center text-sm">
                            {fichier.length !== 0 ? "" : "Charger le fichier"}
                          </p>
                          <div className="flex justify-center">
                            <input
                              className="text-sm mx-auto file-input-bordered mb-3 file-input file-input-ghost w-full max-w-xs"
                              type="file"
                              id="fichier"
                              onChange={handleChangeFichier}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </label>
                  <a
                    href={modelCommune}
                    download="modelCommune"
                    className="btn text-white bg-black btn-sm mx-1"
                  >
                    Telecharger le model
                  </a>
                  <button
                    onClick={() => {
                      setIsSubmit(true);
                      store(CHARGER_FICHIER_COMMUNE, "multipart/form-data", {
                        liste: fichier[0],
                      })
                        .then((res) => {
                          if (res.status === 200) {
                            setIsSubmit(null);
                            document.getElementById("close_upload").click();
                            communes.getData(
                              `${LISTE_COMMUNE_PAR_PAGE}?page=0&param=&size=10`
                            );
                            toast.success("Fichier chargé avec succès");
                          }
                        })
                        .catch((err) => {
                          setIsSubmit(false);
                          setMessage(err?.response?.data?.donnee);
                        });
                    }}
                    disabled={
                      isSubmit ? true : fichier.length === 0 ? true : false
                    }
                    className="font-mtn bg-main btn btn-sm"
                  >
                    charger le fichier
                  </button>
                </div>
              </div>
            </dialog>
          </div>
          <div className="grid md:grid-cols-3 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-6 gap-2 my-8">
            {communes?.data?.data?.length === 0 ? (
              "Aucune donnée"
            ) : communes?.data?.data?.length !== 0 && !communes?.loading ? (
              communes?.data?.data?.map((item) => (
                <div
                  key={item.id}
                  className="relative flex flex-col gap-1 cursor-pointer text-black shadow-sm border bg-white rounded text-xs"
                >
                  <div className="dropdown dropdown-end absolute right-2 top-2 z-10">
                    <div
                      tabIndex={0}
                      role="button"
                      className="w-6 h-6 rounded-full flex items-center justify-center bg-gray-50 hover:bg-gray-100"
                    >
                      <MoreHorizontal size={16} />
                    </div>
                    <ul
                      tabIndex={0}
                      className="mt-1 dropdown-content z-[1] menu p-2 border shadow bg-base-100 rounded-lg w-44"
                    >
                      <button
                        className="bg-white hover:bg-gray-100 text-gray-600 h-9 w-full flex items-center justify-start rounded-lg px-3"
                        onClick={() => {
                          setItem(item);
                        }}
                      >
                        Voir quartiers
                      </button>
                      <button
                        onClick={() => {
                          setSelectItem(item);
                          document.getElementById("update").showModal();
                        }}
                        className="bg-white hover:bg-gray-100 text-gray-600 h-9 w-full flex items-center justify-start rounded-lg px-3"
                      >
                        Modifier
                      </button>
                      <button
                        onClick={() => {
                          setSelectItem(item);
                          document.getElementById("change_status").showModal();
                        }}
                        className="bg-white hover:bg-gray-100 text-gray-600 h-9 w-full flex items-center justify-start rounded-lg px-3"
                      >
                        Modifier état
                      </button>
                    </ul>
                  </div>
                  <div className="flex gap-2 items-center p-3">
                    <div className="bg-main w-10 h-10 rounded flex items-center justify-center flex-shrink-0"></div>
                    <div className="flex-1 min-w-0">
                      <p className="truncate font-medium">{item.designation}</p>
                      {item.typeEtat !== null && (
                        <span
                          className={`badge badge-sm ${getEtatBadge(
                            item.typeEtat
                          )} mt-1`}
                        >
                          {getEtatLabel(item.typeEtat)}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <Loader />
            )}
          </div>
          <div className="my-3 flex justify-end">
            <Pagination
              onChange={(event, newValue) => more(newValue)}
              onSelect={(selectedPage) => more(selectedPage)}
              count={communes?.data?.totalPages}
              variant="outlined"
              color="primary"
              shape="rounded"
            />
          </div>
        </div>
      ) : (
        <div className="my-3">
          <div className="flex items-center gap-1">
            <button
              className="btn bg-white btn-sm"
              onClick={() => {
                setItem(null);
              }}
            >
              <CaretLeftIcon />
            </button>
            <p>{item?.designation}</p>
            <span className={`badge ${getEtatBadge(item.etat)} ml-2`}>
              {getEtatLabel(item.etat)}
            </span>
          </div>

          <Quartier id={item?.id} />
        </div>
      )}
    </>
  );
};
